import { createFileRoute } from "@tanstack/react-router";

import { ComplianceTaskForm } from "@/components/compliance/ComplianceTaskForm";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { useGetTaskDefinitionByIdQueryControllerGet } from "@/generated/compliance-tasks/compliance-tasks";
import { FEATURES } from "@/lib/features";

export const Route = createFileRoute(
  "/_authenticated/compliance/$definitionId/edit",
)({
  component: EditComplianceTaskPage,
});

function EditComplianceTaskPage() {
  const { definitionId } = Route.useParams();

  const { data: definitionResponse, isLoading } =
    useGetTaskDefinitionByIdQueryControllerGet(definitionId);

  const definition = definitionResponse?.data ?? null;

  return (
    <FeatureGate
      feature={FEATURES.COMPLIANCE_TASKS}
      featureName="Compliance tasks"
    >
      <ComplianceTaskForm
        key={definition?.id}
        mode="edit"
        definition={definition}
        isLoading={isLoading}
      />
    </FeatureGate>
  );
}
